__turbopack_context__.v({
  "tooltip": "oH1Cla_tooltip",
  "tooltipContent": "oH1Cla_tooltipContent",
  "tooltipTime": "oH1Cla_tooltipTime",
  "tooltipTitle": "oH1Cla_tooltipTitle",
});
